<template>
  <div class="register-page">
    <div class="register-header">
      <div class="logo-icon">
        <van-icon name="gold-coin-o" size="48" color="#fff" />
      </div>
      <h1>SharePay</h1>
      <p>申请成为博主</p>
    </div>

    <div class="register-card">
      <h3 class="card-title">博主注册</h3>
      <van-form @submit="onRegister">
        <van-field
          v-model="username"
          left-icon="user-o"
          label="用户名"
          placeholder="请输入用户名或手机号"
          :rules="[{ required: true, message: '请输入用户名或手机号' }]"
        />
        <van-field
          v-model="nickname"
          left-icon="contact"
          label="昵称"
          placeholder="请输入昵称"
          :rules="[{ required: true, message: '请输入昵称' }]"
        />
        <van-field
          v-model="password"
          left-icon="lock"
          label="密码"
          placeholder="请输入密码"
          type="password"
          :rules="[{ required: true, message: '请输入密码' }]"
        />
        <van-field
          v-model="captchaCode"
          left-icon="shield-o"
          label="验证码"
          placeholder="请输入验证码"
          :rules="[{ required: true, message: '请输入验证码' }]"
        />
        <div @click="refreshCaptcha" v-html="captchaSvg" class="captcha-box" />
        <van-button
          round block native-type="submit"
          :loading="loading"
          color="linear-gradient(135deg, #6366f1, #8b5cf6)"
          class="submit-btn"
        >
          提交申请
        </van-button>
      </van-form>
      <div class="register-footer">
        已有账号？<router-link to="/login">去登录</router-link>
      </div>
    </div>
  </div>
</template>

<script>
import { authApi } from '../api';

export default {
  data() {
    return {
      username: '', nickname: '', password: '', captchaCode: '',
      captchaSvg: '', captchaKey: '', loading: false
    };
  },
  created() { this.refreshCaptcha(); },
  methods: {
    async refreshCaptcha() {
      try {
        const res = await authApi.getCaptcha();
        this.captchaSvg = res.data.svg;
        this.captchaKey = res.data.captchaKey || res.data.key;
        this.captchaCode = '';
      } catch (e) { /* ignore */ }
    },
    async onRegister() {
      this.loading = true;
      try {
        await authApi.bloggerRegister({
          username: this.username, password: this.password,
          captchaKey: this.captchaKey, captchaCode: this.captchaCode,
          nickname: this.nickname
        });
        this.$toast.success('注册成功，请等待管理员审核');
        this.$router.replace('/login');
      } catch (e) {
        this.refreshCaptcha();
      } finally { this.loading = false; }
    }
  }
};
</script>

<style scoped>
.register-page {
  min-height: 100vh;
  background: linear-gradient(180deg, #6366f1 0%, #8b5cf6 40%, #f5f7fa 40%);
  padding-bottom: 40px;
}
.register-header {
  text-align: center;
  padding: 48px 0 32px;
  color: #fff;
}
.logo-icon {
  width: 80px; height: 80px; border-radius: 24px;
  background: rgba(255,255,255,0.2);
  display: flex; align-items: center; justify-content: center;
  margin: 0 auto 16px;
}
.register-header h1 {
  font-size: 28px; font-weight: 700; margin: 0 0 4px;
}
.register-header p {
  font-size: 14px; opacity: 0.85; margin: 0;
}
.register-card {
  margin: 0 20px;
  background: #fff;
  border-radius: 16px;
  padding: 24px 16px 20px;
  box-shadow: 0 8px 24px rgba(0,0,0,0.08);
}
.card-title {
  font-size: 18px; font-weight: 600; text-align: center;
  margin: 0 0 16px; color: #1f2937;
}
.submit-btn { margin-top: 20px; }
.register-footer {
  text-align: center; margin-top: 16px;
  font-size: 13px; color: #9ca3af;
}
.register-footer a { color: #6366f1; font-weight: 500; }
.captcha-box {
  width: 110px; height: 42px; cursor: pointer;
  border-radius: 6px; overflow: hidden; border: 1px solid #e5e7eb;
  margin-left: auto; margin-top: -8px; margin-right: 16px;
}
.captcha-box >>> svg { width: 100%; height: 100%; }

/* 覆盖验证失败时输入框及 placeholder 的变红样式 */
.register-card >>> .van-field--error .van-field__control::placeholder {
  color: #c8c9cc !important;
  -webkit-text-fill-color: #c8c9cc !important;
}
.register-card >>> .van-field--error .van-field__control {
  color: #323233 !important;
  -webkit-text-fill-color: #323233 !important;
}
</style>
